import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import Navbar from "../Components/Navbar";
import ContactFooter from "../Components/ContactFooter";
import {ErrorMessage} from "../Components/ErrorMessage";

export function Login() {
  const navigate = useNavigate();

  const isLoggedIn = typeof window !== "undefined" && Boolean(localStorage.getItem("token"));

  const emptyErrors = {
    email: "",
    password: ""
  };

  const [errors, setErrors] = useState(emptyErrors);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleLogin = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    
    setError("");

    const tempErrors = {...emptyErrors};
    
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        tempErrors[key as keyof typeof tempErrors] = "Dit veld is verplicht.";
      }
    });

    setErrors(tempErrors);

    if (Object.values(tempErrors).some(error => error !== "")) {
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/Auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) {
        if (response.status === 401) {
          setError("Inloggegevens zijn verkeerd.")
        } else if (response.status === 429) {
          setError("Te veel pogingen, probeer het later opnieuw.")
        } else {
          setError("Inloggen mislukt");
        }
        throw new Error("Login failed");
      }

      const data = await response.json();
      localStorage.setItem("token", data.token);
      console.log("Login successful!");

      navigate('/weekmenu');
    } catch (error) {
      console.error(error);
    }
  };
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate('/');
  };

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Navbar/>

      <div className="white-text-block white-text-block--center">
        <div className="text-block">
          <h1 className="header-1">{isLoggedIn ? "Log uit" : "Log in"}</h1>
          <p>
            {isLoggedIn
              ? "Klik op de onderstaande knop om uit te loggen."
              : "Log in om deze pagina te zien."}
          </p>
        </div>

        {isLoggedIn ? (
          <button className="button" type="button" onClick={handleLogout}>Log uit</button>
        ) : (
          <form onSubmit={handleLogin}>
            <ul>
              <li className="form-item">
                <h3 className="input-label">E-mail</h3>
                <input className="input-field input-field--long" type="text" name="email"
                       value={formData.email} onChange={handleChange}/>
                <ErrorMessage error={errors.email} />

              </li>
              <li className="form-item">
                <h3 className="input-label">Wachtwoord</h3>
                <input className="input-field input-field--long" type="password" name="password"
                       value={formData.password} onChange={handleChange}/>
                <ErrorMessage error={errors.password} />
              </li>
            </ul>

            <button className="button" type="submit">Log in</button>
            <ErrorMessage error={error} />
          </form>
        )}
      </div>

      <ContactFooter />
    </>
  );
}

export default Login;